import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, ViewChildren, ElementRef, Input, Output, EventEmitter, SimpleChange, QueryList} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { QnSbnService } from './../services/qn-sbn-service.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { QnSbnDataService } from './../services/qn-sbn-data-service.service';
import { AppUtils } from '../utils/app-utils';
import { snackbarService } from '@one/web-components';
import { CommonModule } from '@angular/common';
import { OneWebComponentsAngularModule } from '@one/angular';
import { CustomerNotificationService } from '../main-page/customer-notification.service';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { take } from 'rxjs/operators';
import { FormControl, AbstractControl } from '@angular/forms';

// // TODO Rename and put in its own module
const PPTX_ICON = `
<svg id="Icons_Expanded" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:none;}</style></defs><path class="cls-1" d="M0,24V0H24"/><g id="pptx_V6R" data-name="pptx V6R"><path d="M14,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V8Zm4,18H6V4h7V9h5Z"/><g id="Chart"><path d="M9.5,15.5H12A2.5,2.5,0,1,1,9.5,13Z"/></g><g id="list"><rect x="13" y="15" width="4" height="1"/><rect x="13" y="17" width="4" height="1"/><rect x="13" y="13" width="4" height="1"/></g></g></svg>
`;

const ZIP_ICON = `
<svg id="Icons_Expanded" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:none;}</style></defs><path class="cls-1" d="M0,24V0H24"/><g id="zip_V8" data-name="zip V8"><path d="M14,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V8Zm4,18H6V4h7V9h5Z"/><g id="zipper"><rect x="9.5" y="18" width="2" height="2"/><rect x="7.5" y="16" width="2" height="2"/><rect x="9.5" y="14" width="2" height="2"/><rect x="7.5" y="12" width="2" height="2"/><rect x="9.5" y="10" width="2" height="2"/><rect x="7.5" y="8" width="2" height="2"/><rect x="9.5" y="6" width="2" height="2"/><rect x="7.5" y="4" width="2" height="2"/></g></g></svg>`;

@Component({
  standalone: true,
  selector: 'dl-file-upload-single',
  templateUrl: './file-upload-single.component.html',
  styleUrls: ['./file-upload-single.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, OneWebComponentsAngularModule]
})
export class FileUploadSingleComponent implements OnInit {
  // @Input() public fileList_Input;
  public file: File;
@ViewChildren('fileDropRefMul') fileDropRefs: QueryList<ElementRef>;
  public totalAllFileSize = 0;
  public fileSizeobject = { size: 0, type: '' };
  public userFileSize = { size: 0, type: '' };
  public fileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
  public notificationId = '';
  public contactNotificationId = '';  
  public allDraftData = {};
  @Input() ackFileFlag: boolean = true;
  @Output() fileSelected = new EventEmitter<File>();
  @Input() feedbackAttachmentId: string;
  @Input() attachmentData: any;
  @Input() control!: AbstractControl | null;
  /**
   * Maximum upload total file size limit collectively is 50MB.  Allowed file types are pdf, csv, doc, ppt, excel, jpg, bmp, png, and gif. Maximum allowed attachment files are 10.
   */
  // @Input() public isNewFromTemplate: boolean;
  
  public fileUploadInputDisabled:boolean = false;
  public deleteIconDisable:boolean = false;
  public filesSingle: any[] = [];
  public fileName: string;
  public fileSize: any;
  public fileDetails: any;
  public publicKeyToken: string | null = null;
  public userType = localStorage.getItem('userType');
  public isNonDialogUser = this.userType === 'isNonDialogUser' ? true : false;
  public constructor( private readonly sanitizer: DomSanitizer,  private _QnSbnService:QnSbnService,private http: HttpClient,private _QnSbnDataService:QnSbnDataService,  public customerservice: CustomerNotificationService,public appUtil: AppUtils, public router: Router, private cdr: ChangeDetectorRef) {  
  }

  public ngOnInit(): void {
    this._QnSbnDataService.resetAll();
    const urlQueryString = window.location.search;
    const parameters = new URLSearchParams(urlQueryString);
    const curnotificationId = parameters.get('notificationId');
    const curcontactnotificationId = parameters.get('contactNotificationId');
    this.publicKeyToken = parameters.get('publicKeyToken');
    this.notificationId = curnotificationId;
    this.contactNotificationId = curcontactnotificationId;

        this._QnSbnDataService.mappingData$.pipe(take(1)).subscribe(storeData=>{
        if(Array.isArray(storeData['customerFeedbackAttachment'])){
          const fileData = storeData['customerFeedbackAttachment'][curnotificationId];
          this.filesSingle = fileData.flat().filter(file => file.feedbackAttachmentId === this.feedbackAttachmentId && Object.keys(file).length > 0);
          this.allDraftData = fileData.flat().filter(file => file.feedbackAttachmentId === this.feedbackAttachmentId && Object.keys(file).length > 0);
          this.notificationId = curnotificationId;
          this.contactNotificationId = curcontactnotificationId;
          if(this.filesSingle.length > 0){
            this.fileUploadInputDisabled = true;
          }
        }         
      })

      if(this.attachmentData && Object.keys(this.attachmentData).length > 0){
      this.filesSingle = [this.attachmentData];
      this.allDraftData = this.filesSingle;
      if(this.filesSingle.length > 0){
        this.fileUploadInputDisabled = true;
        this.deleteIconDisable = true;
        this.cdr.detectChanges();
      }else{
        this.filesSingle = [];
        this.allDraftData = [];
      }
    }
  }

  /**
   * on file drop handler
   */
  public onFileDroppedandSelect(event: any): void {
    const file = event.target.files
    if (file) {
      this.fileSelected.emit(file);
    } else {
      this.fileSelected.emit(null);
    }
    this.addfile(file);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  public deleteFile(index: number): void {  
    // console.log('index is ---',index);
    this.filesSingle.splice(index,1);
    this.fileUploadInputDisabled = false;
    this.control.setValue(null);
    this.addProduct();
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  public prepareFilesList(files: any): void {
    const filetype: string = files.type;
    files.uploadFile = true;
    switch (filetype) {
      case 'image/apng':
      case 'image/bmp':
      case 'image/gif':
      case 'image/pjpeg':
      case 'image/png':
      case 'image/jpeg':
        files.fileIcon = 'image';
        break;
      case 'text/csv':
      case '.csv':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      case 'application/vnd.ms-excel':
        files.fileIcon = 'file_excel';
        break;
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        files.fileIcon = 'file_word';
        break;
      case 'application/pdf':
        files.fileIcon = 'file_pdf';
        break;
      case 'application/mspowerpoint':
      case 'application/powerpoint':
      case 'application/vnd.ms-powerpoint':
      case 'application/x-mspowerpoint':
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        files.fileIcon = 'pptx_Icon';
        break;
      case 'application/x-7z-compressed':
      case 'application/zip':
      case 'application/x-tar':
      case 'application/vnd.rar':
      case 'application/x-zip-compressed':
      case 'application/x-compressed':
      case 'application/gzip':
        files.fileIcon = 'zip_Icon';
        break;
      default:
        files.fileIcon = 'document'; // icon is not available , temp document used
        break;
    }
    if(!(/[!@#$%^&*,?"{}|<>]/).test(files.name)){
      if(files.size > 0 && files.size <= 15000000){
        files.feedbackAttachmentId = this.feedbackAttachmentId;
        files.fileName = files.name;
        files.fileSize = files.size;
        this.filesSingle = [];
        this.fileUploadInputDisabled = true;      
        this.filesSingle.push(files); 
        this.addProduct();      
      }else if(files.size <=0 || files.size > 15000000){
        this.control.setValue(null);
        this.filesSingle.length = 0;
        snackbarService.show({
        message: 'File size is either 0 MB or greater than 15 MB to upload.', 
        snackbarProps: {
          status: 'alarm',
          direction: 'horizontal',
          showClose: true,
          elevated: false,
          duration: 5000,
          verticalPlacement: 'top',
          horizontalPlacement: 'right',
        }
      });
        return;
      }
    }else{
       this.control.setValue(null);
       snackbarService.show({
        message: 'File name should not have special characters !@#$%^&*,?"{}|<>', 
        snackbarProps: {
          status: 'alarm',
          direction: 'horizontal',
          showClose: true,
          elevated: false,
          duration: 5000,
          verticalPlacement: 'top',
          horizontalPlacement: 'right',
        }
      });
      return;
    }
    
    // this.dataToBeSaveOnS3(files.name);
    // this.maxFileAllowed = this.maxFileAllowed+1;
   
    snackbarService.show({
          message: 'Attachment successfully added', 
          snackbarProps: {
            status: 'positive',
            direction: 'horizontal',
            showClose: true,
            elevated: false,
            duration: 5000,
            verticalPlacement: 'top',
            horizontalPlacement: 'right',
          }
        });
  }

  public bytesCalculation(bytes: number, decimals: number = 2): any {
    if (bytes === 0) {
      this.userFileSize.size = 0;
      this.userFileSize.type = '';
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    this.userFileSize.size = 0;
    this.userFileSize.type = '';

    this.userFileSize.size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    this.userFileSize.type = sizes[i];
    return this.userFileSize;
  }
  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  public formatBytes(bytes: number, decimals: number = 2): string {
    this.bytesCalculation(bytes, decimals);
    return this.userFileSize.size + ' ' + this.userFileSize.type;
  }

  public validFileType(file: File): boolean {
    return this.fileTypes.includes(file.type);
  }

  public addfile(event: any): void {
    for (const item of event) {
      if (this.validFileType(item)) {
        this.prepareFilesList(item);
      } else {
         this.control.setValue(null);
        snackbarService.show({
        message: item.name + ' is not supported file type.', 
        snackbarProps: {
          status: 'alarm',
          direction: 'horizontal',
          showClose: true,
          elevated: false,
          duration: 5000,
          verticalPlacement: 'top',
          horizontalPlacement: 'right',
        }
      });
      }
    }
   // Reset only the input for this feedbackAttachmentId
  const inputToReset = this.fileDropRefs.find(ref =>
    ref.nativeElement.id === 'fileDropRefMul-' + this.feedbackAttachmentId
  );
  if (inputToReset) {
    inputToReset.nativeElement.value = '';
  }
  }

  public addProduct() { 
    console.log('filesSingle--add product',this.filesSingle);
    console.log('notificationId--',this.notificationId);
    this._QnSbnDataService.getMappedQnsbnData(this.filesSingle,"customerFeedbackAttachment", this.notificationId);
  }

  public downloadAttachment(fileName: string) {
    const isSavedFile = this.verifyAttachment(fileName);
    if(isSavedFile) {
      this.customerservice.downloadLocalAttachmentApi(fileName, this.notificationId, this.contactNotificationId, this.publicKeyToken ? this.publicKeyToken : null, false);
    } else {
      return;
    }
  }

  public verifyAttachment(fileName: string): boolean {
    const uploadedFiles = this.allDraftData[0] || [];
    const isSavedFile = uploadedFiles.fileName === fileName ? true : false;
    return isSavedFile;
  }

}
